// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import ChevronRight from "@hardwoods/XDL/Icons/ChevronRight";
import { ellipsis } from "@hardwoods/XDL/Utilities";
import { xScreen } from "@hardwoods/XDL/Utilities/MediaQuery";
import { LinkPresentationProps } from "@insite/mobius/Link";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";

export interface SolutionCardStyles {
    wrapper?: InjectableCss;
    image?: InjectableCss;
    title?: TypographyPresentationProps;
    content?: TypographyPresentationProps;
    link?: LinkPresentationProps;
}

export const solutionCardStyles: SolutionCardStyles = {
    wrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            width: 100%;
            height: 100%;
            max-width: 277px;
            ${xScreen.lte("lg")} {
                margin-bottom: 14px;
            }
            ${xScreen.lte("sm")} {
                margin: auto;
            }
        `,
    },
    image: {
        css: css`
            width: 100%;
            height: 200px;
            margin-bottom: 15px;
        `,
    },
    title: {
        variant: "h5",
        size: 18,
        weight: "normal",
        css: css`
            line-height: 22px;
            margin-bottom: 15px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        `,
    },
    content: {
        variant: "p",
        size: 15,
        css: css`
            margin-bottom: 10px;
            ${ellipsis(3)}
        `,
    },
    link: {
        icon: {
            iconProps: { src: ChevronRight, size: 9 },
        },
        css: css`
            margin-top: auto;
            font-weight: bold;
            align-self: flex-start;
            svg {
                color: ${getColor("common.ui1")};
            }
        `,
    },
};
